// src/components/Admin/Cantieri/MezziManagement.jsx
import React, { useState, useEffect } from 'react';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  query, 
  orderBy,
  where
} from 'firebase/firestore';
import { db } from '../../../firebase';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../../../assets/logo.png';
import './MezziManagement.css';

const MezziManagement = () => {
  const [mezzi, setMezzi] = useState([]);
  const [filteredMezzi, setFilteredMezzi] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterProprieta, setFilterProprieta] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [showStoricoUtilizzoModal, setShowStoricoUtilizzoModal] = useState(false);
  const [selectedMezzo, setSelectedMezzo] = useState(null);
  const [dataInizioUtilizzo, setDataInizioUtilizzo] = useState('');
  const [dataFineUtilizzo, setDataFineUtilizzo] = useState('');
  const [loadingPDF, setLoadingPDF] = useState(false);

  // Stati per storico MANUTENZIONI (NUOVO)
const [showStoricoManutenzioniModal, setShowStoricoManutenzioniModal] = useState(false);
const [storicoManutenzioni, setStoricoManutenzioni] = useState([]);
const [loadingStoricoManutenzioni, setLoadingStoricoManutenzioni] = useState(false);
const [dataInizioManutenzioni, setDataInizioManutenzioni] = useState('');
const [dataFineManutenzioni, setDataFineManutenzioni] = useState('');
  
  const [formData, setFormData] = useState({
    nomeMezzo: '',
    targa: '',
    costoOrario: '',
    proprieta: '',
    note: ''
  });

  // Opzioni proprietà
  const proprietaOptions = [
    'Isap',
    'Fd', 
    'Stradedg',
    'Eurosafe',
    'Noleggio'
  ];

  // Dati completi dal file Excel (tutti i 152 mezzi)
  const mezziCompleti = [
    { nomeMezzo: 'FIAT SCUDO', targa: 'FC002HC', costoOrario: 8, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO DAF', targa: 'CW443NN', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO DAF', targa: 'DM272MW', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO DAF', targa: 'DM383MW', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO DAF', targa: 'DP772JM', costoOrario: 12.5, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO IVECO', targa: 'DF829CV', costoOrario: 12.5, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO IVECO', targa: 'DY645JP', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'AUTOARTICOLATO IVECO', targa: 'FJ819PD', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'AUTOCARRO IVECO', targa: 'GH399VW', costoOrario: 12.5, proprieta: 'Isap', note: '' },
    { nomeMezzo: 'ESCAVATORE SANY MODELLO SY 215C NLC', targa: '', costoOrario: 25, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'FURGONE IVECO', targa: 'EH984WV', costoOrario: 8, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'PALA GOMMATA CAT 938M', targa: 'ALL543', costoOrario: 16, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'MINIPALA CINGOLATA CAT 289D', targa: 'AKZ673', costoOrario: 12, proprieta: 'Fd', note: '' },
    { nomeMezzo: 'RULLO CAT CB10', targa: 'NPP00103', costoOrario: 15, proprieta: 'Fd', note: '' },
  ];

  // Caricamento mezzi da Firebase
  const loadMezzi = async () => {
    try {
      setIsLoading(true);
      const mezziQuery = query(
        collection(db, 'mezzi'),
        orderBy('nomeMezzo', 'asc')
      );
      
      const snapshot = await getDocs(mezziQuery);
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setMezzi(data);
      console.log(`Caricati ${data.length} mezzi`);
    } catch (error) {
      console.error("Errore nel caricamento mezzi:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Importazione massiva dei mezzi completi
  const importMezziCompleti = async () => {
    try {
      setIsLoading(true);
      console.log('Avvio importazione di tutti i mezzi dal file Excel...');
      
      const batch = [];
      for (const mezzo of mezziCompleti) {
        const mezzoData = {
          ...mezzo,
          createdAt: new Date(),
          updatedAt: new Date()
        };
        batch.push(addDoc(collection(db, 'mezzi'), mezzoData));
      }
      
      await Promise.all(batch);
      console.log(`Importati ${mezziCompleti.length} mezzi dal file Excel`);
      
      await loadMezzi();
      setShowBulkImport(false);
      alert(`✅ ${mezziCompleti.length} mezzi importati con successo!`);
    } catch (error) {
      console.error("Errore nell'importazione mezzi:", error);
      alert('Errore durante l\'importazione dei mezzi');
    } finally {
      setIsLoading(false);
    }
  };

  // Applicazione filtri
  const applyFilters = () => {
    let filtered = [...mezzi];

    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      filtered = filtered.filter(mezzo => 
        mezzo.nomeMezzo.toLowerCase().includes(search) ||
        (mezzo.targa && mezzo.targa.toLowerCase().includes(search)) ||
        (mezzo.note && mezzo.note.toLowerCase().includes(search))
      );
    }

    if (filterProprieta !== 'all') {
      filtered = filtered.filter(mezzo => mezzo.proprieta === filterProprieta);
    }

    setFilteredMezzi(filtered);
  };

  // Reset del form
  const resetForm = () => {
    setFormData({
      nomeMezzo: '',
      targa: '',
      costoOrario: '',
      proprieta: '',
      note: ''
    });
    setEditingId(null);
    setShowForm(false);
  };

  // Gestione input form
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Salvataggio mezzo
  const saveMezzo = async (e) => {
    e.preventDefault();
    
    if (!formData.nomeMezzo.trim()) {
      alert('Il nome del mezzo è obbligatorio');
      return;
    }

    try {
      setIsLoading(true);
      
      const mezzoData = {
        nomeMezzo: formData.nomeMezzo.trim(),
        targa: formData.targa.trim(),
        costoOrario: parseFloat(formData.costoOrario) || 0,
        proprieta: formData.proprieta,
        note: formData.note.trim(),
        updatedAt: new Date()
      };

      if (editingId) {
        const mezzoRef = doc(db, 'mezzi', editingId);
        await updateDoc(mezzoRef, mezzoData);
        console.log('Mezzo aggiornato:', editingId);
      } else {
        mezzoData.createdAt = new Date();
        await addDoc(collection(db, 'mezzi'), mezzoData);
        console.log('Nuovo mezzo creato');
      }

      resetForm();
      await loadMezzi();
      alert('✅ Mezzo salvato con successo!');
    } catch (error) {
      console.error("Errore nel salvataggio mezzo:", error);
      alert('Errore nel salvataggio del mezzo');
    } finally {
      setIsLoading(false);
    }
  };

  // Modifica mezzo
  const editMezzo = (mezzo) => {
    setFormData({
      nomeMezzo: mezzo.nomeMezzo,
      targa: mezzo.targa || '',
      costoOrario: mezzo.costoOrario?.toString() || '',
      proprieta: mezzo.proprieta || '',
      note: mezzo.note || ''
    });
    setEditingId(mezzo.id);
    setShowForm(true);
  };

  // Eliminazione mezzo
  const deleteMezzo = async (mezzoId, nomeMezzo) => {
    if (!window.confirm(`Sei sicuro di voler eliminare il mezzo "${nomeMezzo}"?`)) {
      return;
    }

    try {
      setIsLoading(true);
      const mezzoRef = doc(db, 'mezzi', mezzoId);
      await deleteDoc(mezzoRef);
      console.log('Mezzo eliminato:', mezzoId);
      await loadMezzi();
      alert('✅ Mezzo eliminato con successo!');
    } catch (error) {
      console.error("Errore nell'eliminazione mezzo:", error);
      alert('Errore nell\'eliminazione del mezzo');
    } finally {
      setIsLoading(false);
    }
  };

  // Apertura modal storico
  const openStoricoUtilizzoModal = (mezzo) => {  // era openStoricoModal
    setSelectedMezzo(mezzo);
    setShowStoricoUtilizzoModal(true);  // era setShowStoricoModal
    // Imposta date di default (ultimo mese)
  const oggi = new Date();
  const unMeseFa = new Date();
  unMeseFa.setMonth(oggi.getMonth() - 1);
  setDataFineUtilizzo(oggi.toISOString().split('T')[0]);  // era setDataFine
  setDataInizioUtilizzo(unMeseFa.toISOString().split('T')[0]);  // era setDataInizio
};

  // Chiusura modal storico
  const closeStoricoUtilizzoModal = () => {  // era closeStoricoUtilizzoModal
    setShowStoricoUtilizzoModal(false);  // era setShowStoricoModal
    setSelectedMezzo(null);
    setDataInizioUtilizzo('');  // era setDataInizio
    setDataFineUtilizzo('');  // era setDataFine
  };

  // ============================================
// STORICO MANUTENZIONI (NUOVO)
// ============================================

const openStoricoManutenzioniModal = (mezzo) => {
  setSelectedMezzo(mezzo);
  setShowStoricoManutenzioniModal(true);
  
  // Imposta date di default (ultimo mese)
  const oggi = new Date();
  const primoGiornoMese = new Date(oggi.getFullYear(), oggi.getMonth(), 1);
  setDataInizioManutenzioni(primoGiornoMese.toISOString().split('T')[0]);
  setDataFineManutenzioni(oggi.toISOString().split('T')[0]);
};

const closeStoricoManutenzioniModal = () => {
  setShowStoricoManutenzioniModal(false);
  setSelectedMezzo(null);
  setStoricoManutenzioni([]);
  setDataInizioManutenzioni('');
  setDataFineManutenzioni('');
};

const caricaStoricoManutenzioni = async () => {
  if (!selectedMezzo || !dataInizioManutenzioni || !dataFineManutenzioni) {
    alert('⚠️ Seleziona date valide');
    return;
  }

  setLoadingStoricoManutenzioni(true);
  
  try {
    const startDate = new Date(dataInizioManutenzioni);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(dataFineManutenzioni);
    endDate.setHours(23, 59, 59, 999);

    // Cerca nei rapportini officina le manutenzioni per questo mezzo
    const rapportiniQuery = query(
      collection(db, 'rapportiniOfficina'),
      where('stato', '==', 'Attivo')
    );
    
    const snapshot = await getDocs(rapportiniQuery);
    const manutenzioni = [];
    
    snapshot.forEach(doc => {
      const rapportino = doc.data();
      const dataRapportino = rapportino.data?.toDate ? rapportino.data.toDate() : new Date(rapportino.data);
      
      // Verifica se il rapportino è nel periodo
      if (dataRapportino >= startDate && dataRapportino <= endDate) {
        // Controlla se questo rapportino contiene lavorazioni per il mezzo selezionato
        if (rapportino.lavorazioni && Array.isArray(rapportino.lavorazioni)) {
          rapportino.lavorazioni.forEach(lav => {
            if (lav.mezzoId === selectedMezzo.id) {
              manutenzioni.push({
                id: doc.id,
                data: dataRapportino,
                tipoLavorazione: lav.tipoLavorazione || 'N/D',
                tempoImpiegato: lav.oreInvestite || 0,
                personaleImpiegato: lav.personaleAssegnato || [],
                km: lav.kmMezzo || 'N/D',
                note: lav.note || ''
              });
            }
          });
        }
      }
    });
    
    // Ordina per data (più recenti prima)
    manutenzioni.sort((a, b) => b.data - a.data);
    
    setStoricoManutenzioni(manutenzioni);
    console.log(`Trovate ${manutenzioni.length} manutenzioni per ${selectedMezzo.nomeMezzo} nel periodo`);
  } catch (error) {
    console.error('Errore nel caricamento storico manutenzioni:', error);
    setStoricoManutenzioni([]);
    alert('❌ Errore nel caricamento dello storico manutenzioni');
  } finally {
    setLoadingStoricoManutenzioni(false);
  }
};

  // Funzione per recuperare i rapportini del mezzo nel periodo
  const getRapportiniMezzo = async (mezzoId, mezzoNome, dataInizio, dataFine) => {
    try {
      const rapportiniRef = collection(db, 'rapportini');
      const q = query(
        rapportiniRef,
        where('stato', '==', 'Attivo')
      );

      const snapshot = await getDocs(q);
      const rapportini = [];

      const startDate = new Date(dataInizio);
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date(dataFine);
      endDate.setHours(23, 59, 59, 999);

      // Carica i cantieri per recuperare i nomi
      const cantieriRef = collection(db, 'cantieri');
      const cantieriSnapshot = await getDocs(cantieriRef);
      const cantieriMap = new Map();
      cantieriSnapshot.forEach(doc => {
        const cantiereData = doc.data();
        cantieriMap.set(doc.id, {
          id: doc.id,
          nome: cantiereData.nomeCommessa || cantiereData.nomeCantiere || 'Cantiere Sconosciuto',
          ...cantiereData
        });
      });

      snapshot.forEach((doc) => {
        const data = doc.data();
        
        // Usa il campo data (che è corretto) invece di nomeRapportino
        let rapportinoDate;
        if (data.data?.toDate && typeof data.data.toDate === 'function') {
          rapportinoDate = data.data.toDate();
        } else if (data.data?.seconds) {
          rapportinoDate = new Date(data.data.seconds * 1000);
        } else if (data.data instanceof Date) {
          rapportinoDate = data.data;
        } else if (typeof data.data === 'string') {
          rapportinoDate = new Date(data.data);
        } else if (typeof data.data === 'number') {
          rapportinoDate = new Date(data.data);
        } else {
          console.warn('Rapportino senza data valida:', doc.id);
          return;
        }

        // Verifica che la data sia valida
        if (isNaN(rapportinoDate.getTime())) {
          console.warn('Data non valida per rapportino:', doc.id);
          return;
        }

        // Crea una stringa data nel formato YYYY-MM-DD dalla data corretta
        const dataString = rapportinoDate.toISOString().split('T')[0];

        // Verifica se il rapportino è nel periodo
        if (rapportinoDate >= startDate && rapportinoDate <= endDate) {
          // Verifica se il mezzo è presente nel rapportino
          if (data.mezziUtilizzati && Array.isArray(data.mezziUtilizzati)) {
            const mezzoNelRapportino = data.mezziUtilizzati.find(m => 
              m.mezzoId === mezzoId || m.nome === mezzoNome
            );

            if (mezzoNelRapportino) {
              // Recupera il nome del cantiere dalla mappa
              const cantiere = cantieriMap.get(data.cantiereId);
              const cantierNome = cantiere?.nome || data.cantierNome || 'Cantiere Sconosciuto';

              rapportini.push({
                id: doc.id,
                dataCorretta: dataString, // Data corretta in formato YYYY-MM-DD
                nomeRapportino: data.nomeRapportino, // Mantieni per debug
                data: rapportinoDate,
                cantiereId: data.cantiereId,
                cantierNome: cantierNome,
                mezzo: mezzoNelRapportino
              });
            }
          }
        }
      });

      // Ordina i rapportini per data corretta
      rapportini.sort((a, b) => a.dataCorretta.localeCompare(b.dataCorretta));

      console.log(`Trovati ${rapportini.length} rapportini per il mezzo nel periodo`);
      if (rapportini.length > 0) {
        console.log('Primo rapportino:', rapportini[0].dataCorretta, '(nomeRapportino era:', rapportini[0].nomeRapportino + ')');
        console.log('Ultimo rapportino:', rapportini[rapportini.length - 1].dataCorretta);
      }
      
      return rapportini;
    } catch (error) {
      console.error("Errore nel recupero rapportini mezzo:", error);
      throw error;
    }
  };

  // Funzione per generare PDF storico mezzo
  const generaStoricoPDF = async () => {
    if (!selectedMezzo || !dataInizioUtilizzo || !dataFineUtilizzo) {
      alert('⚠️ Seleziona date valide');
      return;
    }

    try {
      setLoadingPDF(true);

      // Recupera i rapportini del mezzo
      const rapportini = await getRapportiniMezzo(
        selectedMezzo.id,
        selectedMezzo.nomeMezzo,
        dataInizioUtilizzo,
        dataFineUtilizzo
      );

      if (rapportini.length === 0) {
        alert('ℹ️ Nessun rapportino trovato per il mezzo nel periodo selezionato');
        return;
      }

      console.log('Rapportini trovati:', rapportini.length);
      console.log('Esempio primo rapportino:', {
        dataCorretta: rapportini[0].dataCorretta,
        nomeRapportino: rapportini[0].nomeRapportino,
        cantierNome: rapportini[0].cantierNome
      });
      
      // Verifica tutte le date e conta duplicati
      const dateCount = {};
      rapportini.forEach(r => {
        const key = `${r.dataCorretta}-${r.cantiereId}`;
        dateCount[key] = (dateCount[key] || 0) + 1;
      });
      
      console.log('Tutte le date (corrette):', rapportini.map(r => r.dataCorretta));
      console.log('Date con duplicati:', Object.entries(dateCount).filter(([k, v]) => v > 1));

      // Crea PDF
      const pdf = new jsPDF();
      const pageWidth = pdf.internal.pageSize.getWidth();
      let yPos = 20;

      // Converti logo in base64
      const logoBase64 = await getLogoBase64();

      // Header con logo
      if (logoBase64) {
        pdf.addImage(logoBase64, 'PNG', 15, 10, 40, 15);
      }

      // Titolo
      pdf.setFontSize(18);
      pdf.setFont('helvetica', 'bold');
      pdf.text('STORICO MEZZO', pageWidth / 2, yPos, { align: 'center' });
      yPos += 15;

      // Informazioni mezzo
      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Mezzo: ${selectedMezzo.nomeMezzo}`, 15, yPos);
      yPos += 7;
      if (selectedMezzo.targa) {
        pdf.text(`Targa: ${selectedMezzo.targa}`, 15, yPos);
        yPos += 7;
      }
      pdf.text(`Proprietà: ${selectedMezzo.proprieta || 'N/A'}`, 15, yPos);
      yPos += 7;
      pdf.text(`Costo Orario: €${selectedMezzo.costoOrario}/h`, 15, yPos);
      yPos += 10;

      // Periodo
      pdf.setFont('helvetica', 'bold');
      pdf.text(`Periodo: ${new Date(dataInizioUtilizzo).toLocaleDateString('it-IT')} - ${new Date(dataFineUtilizzo).toLocaleDateString('it-IT')}`, 15, yPos);
      yPos += 10;

      // Raggruppa per cantiere
      const rapportiniPerCantiere = rapportini.reduce((acc, r) => {
        if (!acc[r.cantiereId]) {
          acc[r.cantiereId] = {
            nome: r.cantierNome,
            rapportini: []
          };
        }
        acc[r.cantiereId].rapportini.push(r);
        return acc;
      }, {});

      // Calcoli totali
      let oreTotali = 0;
      let costoTotale = 0;

      // Tabella riepilogo per cantiere
      const tableData = [];
      
      Object.values(rapportiniPerCantiere).forEach(cantiere => {
        // Aggrega per data CORRETTA per evitare duplicati nello stesso giorno
        const rapportiniPerData = {};
        
        cantiere.rapportini.forEach(r => {
          const dataKey = r.dataCorretta; // Usa dataCorretta invece di nomeRapportino
          if (!rapportiniPerData[dataKey]) {
            rapportiniPerData[dataKey] = {
              ore: 0,
              costo: 0
            };
          }
          rapportiniPerData[dataKey].ore += parseFloat(r.mezzo.ore || r.mezzo.oreLavorate || 0);
          rapportiniPerData[dataKey].costo += parseFloat(r.mezzo.totale || 0);
        });
        
        const giorniUnici = Object.keys(rapportiniPerData).length;
        const oreCantiere = Object.values(rapportiniPerData).reduce((sum, d) => sum + d.ore, 0);
        const costoCantiere = Object.values(rapportiniPerData).reduce((sum, d) => sum + d.costo, 0);

        oreTotali += oreCantiere;
        costoTotale += costoCantiere;

        tableData.push([
          cantiere.nome,
          giorniUnici.toString(),
          oreCantiere.toFixed(2) + ' h',
          '€' + costoCantiere.toFixed(2)
        ]);
      });

      // Aggiungi riga totali
      tableData.push([
        { content: 'TOTALE', styles: { fontStyle: 'bold' } },
        { content: rapportini.length.toString(), styles: { fontStyle: 'bold' } },
        { content: oreTotali.toFixed(2) + ' h', styles: { fontStyle: 'bold' } },
        { content: '€' + costoTotale.toFixed(2), styles: { fontStyle: 'bold' } }
      ]);

      // Riepilogo per cantiere
      autoTable(pdf, {
        startY: yPos,
        head: [['Cantiere', 'N° Giorni', 'Ore Lavorate', 'Costo Totale']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: 'bold' },
        styles: { fontSize: 10, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 80 },
          1: { cellWidth: 30, halign: 'center' },
          2: { cellWidth: 35, halign: 'right' },
          3: { cellWidth: 40, halign: 'right' }
        }
      });

      yPos = pdf.lastAutoTable.finalY + 15;

      // Nuova pagina per dettaglio giornaliero
      pdf.addPage();
      yPos = 20;

      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.text('DETTAGLIO GIORNALIERO', pageWidth / 2, yPos, { align: 'center' });
      yPos += 10;

      // Tabella dettaglio giornaliero - aggrega per data CORRETTA/cantiere
      const rapportiniAggregati = {};
      
      rapportini.forEach(r => {
        const key = `${r.dataCorretta}-${r.cantiereId}`;
        
        if (!rapportiniAggregati[key]) {
          rapportiniAggregati[key] = {
            dataCorretta: r.dataCorretta,
            cantierNome: r.cantierNome,
            ore: 0,
            costo: 0
          };
        }
        
        rapportiniAggregati[key].ore += parseFloat(r.mezzo.ore || r.mezzo.oreLavorate || 0);
        rapportiniAggregati[key].costo += parseFloat(r.mezzo.totale || 0);
      });
      
      // Converti in array e ordina per data
      const rapportiniUnici = Object.values(rapportiniAggregati).sort((a, b) => 
        a.dataCorretta.localeCompare(b.dataCorretta)
      );
      
      const dettaglioData = rapportiniUnici.map(r => {
        // Converti da dataCorretta (YYYY-MM-DD) a formato italiano (DD/MM/YYYY)
        let dataFormattata = 'Data non disponibile';
        
        if (r.dataCorretta && typeof r.dataCorretta === 'string') {
          const parti = r.dataCorretta.split('-');
          if (parti.length === 3) {
            const [anno, mese, giorno] = parti;
            dataFormattata = `${giorno}/${mese}/${anno}`;
          }
        }
        
        return [
          dataFormattata,
          r.cantierNome,
          r.ore.toFixed(2) + ' h',
          '€' + r.costo.toFixed(2)
        ];
      });

      autoTable(pdf, {
        startY: yPos,
        head: [['Data', 'Cantiere', 'Ore', 'Costo']],
        body: dettaglioData,
        theme: 'striped',
        headStyles: { fillColor: [0, 123, 255], textColor: 255, fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 2 },
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 90 },
          2: { cellWidth: 30, halign: 'right' },
          3: { cellWidth: 35, halign: 'right' }
        }
      });

      // Footer
      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        pdf.text(
          `Pagina ${i} di ${pageCount} - Generato il ${new Date().toLocaleDateString('it-IT')}`,
          pageWidth / 2,
          pdf.internal.pageSize.getHeight() - 10,
          { align: 'center' }
        );
      }

      // Salva PDF
      const nomeFile = `Storico_${selectedMezzo.nomeMezzo.replace(/\s+/g, '_')}_${dataInizioUtilizzo}_${dataFineUtilizzo}.pdf`;
      pdf.save(nomeFile);

      alert('✅ PDF generato con successo!');
      closeStoricoUtilizzoModal();

    } catch (error) {
      console.error("Errore nella generazione PDF:", error);
      alert('❌ Errore nella generazione del PDF: ' + error.message);
    } finally {
      setLoadingPDF(false);
    }
  };

  // Funzione per convertire logo in base64
  const getLogoBase64 = () => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = this.width;
        canvas.height = this.height;
        ctx.drawImage(this, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => resolve(null);
      img.src = logo;
    });
  };

  // Caricamento iniziale
  useEffect(() => {
    loadMezzi();
  }, []);

  // Applicazione filtri quando cambiano i dati o i filtri
  useEffect(() => {
    applyFilters();
  }, [mezzi, searchTerm, filterProprieta]);

  return (
    <div className="mezzi-management-container">
      <div className="mezzi-header">
        <h2>🚜 Gestione Mezzi</h2>
        <div className="mezzi-header-actions">
          <button 
            className="btn-import"
            onClick={() => setShowBulkImport(true)}
            disabled={isLoading}
          >
            📥 Importa Mezzi
          </button>
          <button 
            className="btn-create"
            onClick={() => setShowForm(true)}
            disabled={isLoading}
          >
            ➕ Nuovo Mezzo
          </button>
        </div>
      </div>

      {/* Filtri */}
      <div className="mezzi-filters">
        <div className="filter-group">
          <label>🔍 Cerca</label>
          <input
            type="text"
            placeholder="Nome, targa, note..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>
        <div className="filter-group">
          <label>🏢 Proprietà</label>
          <select
            value={filterProprieta}
            onChange={(e) => setFilterProprieta(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tutte</option>
            {proprietaOptions.map(prop => (
              <option key={prop} value={prop}>{prop}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Lista Mezzi */}
      {isLoading ? (
        <div className="loading-state">⏳ Caricamento mezzi...</div>
      ) : filteredMezzi.length === 0 ? (
        <div className="empty-state">
          📭 Nessun mezzo trovato
        </div>
      ) : (
        <div className="mezzi-grid">
          {filteredMezzi.map((mezzo) => (
            <div key={mezzo.id} className="mezzo-card">
              <div className="mezzo-card-header">
                <h3>{mezzo.nomeMezzo}</h3>
                {mezzo.targa && <span className="mezzo-targa">{mezzo.targa}</span>}
              </div>
              <div className="mezzo-card-body">
                <div className="mezzo-info">
                  <span className="info-label">💶 Costo Orario:</span>
                  <span className="info-value">€{mezzo.costoOrario}/h</span>
                </div>
                {mezzo.proprieta && (
                  <div className="mezzo-info">
                    <span className="info-label">🏢 Proprietà:</span>
                    <span className="info-value">{mezzo.proprieta}</span>
                  </div>
                )}
                {mezzo.note && (
                  <div className="mezzo-info">
                    <span className="info-label">📝 Note:</span>
                    <span className="info-value">{mezzo.note}</span>
                  </div>
                )}
              </div>
              <div className="mezzo-card-actions">
  <button
    className="btn-storico"
    onClick={() => openStoricoUtilizzoModal(mezzo)}  // era openStoricoModal
    title="Storico utilizzo cantieri"
  >
  Storico Utilizzo
  </button>
  <button
    className="btn-manutenzioni"  // NUOVO BOTTONE
    onClick={() => openStoricoManutenzioniModal(mezzo)}
    title="Storico manutenzioni"
  >
  Manutenzioni
  </button>
  <button
    className="btn-edit"
    onClick={() => editMezzo(mezzo)}
  >
  </button>
  <button
    className="btn-delete"
    onClick={() => deleteMezzo(mezzo.id, mezzo.nomeMezzo)}
  >
  </button>
</div>
            </div>
          ))}
        </div>
      )}

      {/* Modal Form Mezzo */}
      {showForm && (
        <div className="modal-overlay mezzi-edit-overlay" onClick={resetForm}>
          <div className="modal-content mezzi-modal mezzi-edit-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingId ? '✏️ Modifica Mezzo' : '➕ Nuovo Mezzo'}</h3>
              <button className="modal-close" onClick={resetForm}>✕</button>
            </div>
            
            <form onSubmit={saveMezzo} className="mezzi-form">
              <div className="form-group">
                <label>Nome Mezzo *</label>
                <input
                  type="text"
                  name="nomeMezzo"
                  value={formData.nomeMezzo}
                  onChange={handleInputChange}
                  required
                  placeholder="Es. FIAT SCUDO"
                />
              </div>

              <div className="form-group">
                <label>Targa</label>
                <input
                  type="text"
                  name="targa"
                  value={formData.targa}
                  onChange={handleInputChange}
                  placeholder="Es. FC002HC"
                />
              </div>

              <div className="form-group">
                <label>Costo Orario (€/h)</label>
                <input
                  type="number"
                  step="0.01"
                  name="costoOrario"
                  value={formData.costoOrario}
                  onChange={handleInputChange}
                  placeholder="Es. 12.50"
                />
              </div>

              <div className="form-group">
                <label>Proprietà</label>
                <select
                  name="proprieta"
                  value={formData.proprieta}
                  onChange={handleInputChange}
                >
                  <option value="">Seleziona proprietà</option>
                  {proprietaOptions.map(prop => (
                    <option key={prop} value={prop}>{prop}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Note</label>
                <textarea
                  name="note"
                  value={formData.note}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Note aggiuntive..."
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={resetForm}>
                  Annulla
                </button>
                <button type="submit" className="btn-save" disabled={isLoading}>
                  {editingId ? 'Aggiorna Mezzo' : 'Crea Mezzo'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Storico Mezzo */}
      {showStoricoUtilizzoModal && selectedMezzo && (  // era showStoricoModal
  <div className="modal-overlay" onClick={closeStoricoUtilizzoModal}>  // era closeStoricoUtilizzoModal
    <div className="modal-content storico-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3>📄 Storico Utilizzo - {selectedMezzo.nomeMezzo}</h3>
        <button onClick={closeStoricoUtilizzoModal} className="modal-close">✕</button>
      </div>
      
      <div className="modal-body">
        <div className="storico-info">
          <p><strong>Mezzo:</strong> {selectedMezzo.nomeMezzo}</p>
          {selectedMezzo.targa && <p><strong>Targa:</strong> {selectedMezzo.targa}</p>}
          <p><strong>Proprietà:</strong> {selectedMezzo.proprieta || 'N/D'}</p>
        </div>

        <div className="date-filters">
          <div className="filter-group">
            <label>📅 Data Inizio</label>
            <input
              type="date"
              value={dataInizioUtilizzo}  // era dataInizio
              onChange={(e) => setDataInizioUtilizzo(e.target.value)}  // era setDataInizio
              className="filter-input"
            />
          </div>
          <div className="filter-group">
            <label>📅 Data Fine</label>
            <input
              type="date"
              value={dataFineUtilizzo}  // era dataFine
              onChange={(e) => setDataFineUtilizzo(e.target.value)}  // era setDataFine
              className="filter-input"
            />
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button 
          type="button" 
          className="btn-cancel" 
          onClick={closeStoricoUtilizzoModal}  // era closeStoricoUtilizzoModal
          disabled={loadingPDF}
        >
          Annulla
        </button>
        <button 
          type="button" 
          className="btn-save" 
          onClick={generaStoricoPDF}
          disabled={loadingPDF || !dataInizioUtilizzo || !dataFineUtilizzo}  // era !dataInizio || !dataFine
        >
          {loadingPDF ? '⏳ Generazione...' : '📥 Scarica PDF'}
        </button>
      </div>
    </div>
  </div>
)}

{/* Modal Storico MANUTENZIONI */}
{showStoricoManutenzioniModal && selectedMezzo && (
  <div className="modal-overlay" onClick={closeStoricoManutenzioniModal}>
    <div className="modal-content storico-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3>🔧 Storico Manutenzioni - {selectedMezzo.nomeMezzo}</h3>
        <button onClick={closeStoricoManutenzioniModal} className="modal-close">✕</button>
      </div>

      <div className="modal-body">
        <div className="storico-info">
          <p><strong>Mezzo:</strong> {selectedMezzo.nomeMezzo}</p>
          {selectedMezzo.targa && <p><strong>Targa:</strong> {selectedMezzo.targa}</p>}
        </div>

        <div className="date-filters">
          <div className="filter-group">
            <label>📅 Data Inizio</label>
            <input
              type="date"
              value={dataInizioManutenzioni}
              onChange={(e) => setDataInizioManutenzioni(e.target.value)}
              className="filter-input"
            />
          </div>
          <div className="filter-group">
            <label>📅 Data Fine</label>
            <input
              type="date"
              value={dataFineManutenzioni}
              onChange={(e) => setDataFineManutenzioni(e.target.value)}
              className="filter-input"
            />
          </div>
        </div>

        <div className="form-actions" style={{justifyContent: 'center', marginBottom: '20px'}}>
          <button 
            type="button" 
            className="btn-primary" 
            onClick={caricaStoricoManutenzioni}
            disabled={loadingStoricoManutenzioni || !dataInizioManutenzioni || !dataFineManutenzioni}
          >
            {loadingStoricoManutenzioni ? '⏳ Caricamento...' : '🔍 Cerca Manutenzioni'}
          </button>
        </div>

        {loadingStoricoManutenzioni ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Caricamento storico...</p>
          </div>
        ) : storicoManutenzioni.length === 0 ? (
          <div className="empty-state">
            <p>📋 Nessuna manutenzione registrata per questo mezzo nel periodo selezionato</p>
          </div>
        ) : (
          <div className="storico-table-container">
            <table className="storico-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Tipo Lavorazione</th>
                  <th>Tempo Impiegato</th>
                  <th>Personale</th>
                  <th>Km</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                {storicoManutenzioni.map((manutenzione, index) => (
                  <tr key={index}>
                    <td>
                      {manutenzione.data.toLocaleDateString('it-IT')}
                    </td>
                    <td>{manutenzione.tipoLavorazione}</td>
                    <td>{manutenzione.tempoImpiegato} ore</td>
                    <td>
                      {manutenzione.personaleImpiegato.length > 0 
                        ? manutenzione.personaleImpiegato.map(p => 
                            `${p.nome} ${p.cognome}`
                          ).join(', ')
                        : 'N/D'
                      }
                    </td>
                    <td>{manutenzione.km}</td>
                    <td>{manutenzione.note || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="modal-footer">
        <button onClick={closeStoricoManutenzioniModal} className="btn-secondary">
          Chiudi
        </button>
      </div>
    </div>
  </div>
)}

      {/* Modal Importazione Massiva */}
      {showBulkImport && (
        <div className="modal-overlay" onClick={() => setShowBulkImport(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📥 Importa Mezzi da Excel</h3>
              <button className="modal-close" onClick={() => setShowBulkImport(false)}>✕</button>
            </div>
            
            <div className="modal-body">
              <p>Stai per importare <strong>{mezziCompleti.length} mezzi</strong> completi dal file Excel fornito.</p>
              <p>Questa operazione aggiungerà tutti i mezzi con proprietà, targhe, costi e note originali.</p>
              
              <div className="preview-list">
                <h4>Anteprima importazione (primi 10 mezzi):</h4>
                <div className="preview-items">
                  {mezziCompleti.slice(0, 10).map((mezzo, index) => (
                    <div key={index} className="preview-item">
                      <strong>{mezzo.nomeMezzo}</strong>
                      {mezzo.targa && ` (${mezzo.targa})`}
                      {" - "}€{mezzo.costoOrario}/h
                      {mezzo.proprieta && ` - ${mezzo.proprieta}`}
                    </div>
                  ))}
                  {mezziCompleti.length > 10 && (
                    <div className="preview-more">
                      ... e altri {mezziCompleti.length - 10} mezzi
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            <div className="form-actions">
              <button 
                type="button" 
                className="btn-cancel" 
                onClick={() => setShowBulkImport(false)}
              >
                Annulla
              </button>
              <button 
                type="button" 
                className="btn-save" 
                onClick={importMezziCompleti}
              >
                Conferma Importazione
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MezziManagement;